export const REPORT_LIST_ROUTE='/reportlist'
export const OPERATIONS_ROUTE='/operations'
export const USERS_ROUTE='/users'
export const LOGIN_ROUTE='/'
export const FILL_DATA_ROUTE = '/fillData'
export const PKI_CERTIFICATES_ROUTE = '/pkiCertificates'
export const ANDES_ROUTE='/andes'
export const SMS_ROUTE='/sms'
export const AUDIT_REPORT_ROUTE='/auditReport'